import { connect } from 'react-redux';
import { HelpAction } from 'Actions/helpAction';
import Help from 'Components/Help';

function mapStatetoProps(state){
    const { responseArray, totalRecords, currentPage, loading } = state.help;
    const { exportHelpData } = state.exportHelpData;
    const { profile } = state;
    return{
        profile: profile.permission && JSON.parse(profile.permission),
        help: responseArray,
        totalRecords,
        currentPage: currentPage,
        loading: loading,
        exportHelpData,
    }
}

const mapDispatchtoProps = {
    fetchHelp: HelpAction.fetchHelp,
    deleteHelp: HelpAction.deleteHelp,
    exportHelp: HelpAction.exportHelp,
}

export default connect(mapStatetoProps,mapDispatchtoProps)(Help)